<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-sm-12">
        <b-card no-body class="mb-1 border border-info shadow-none">
          <b-card-header class="bg-info" header-tag="header">
            <h6 class="m-0 text-white">
              Informações sobre o Pedido
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <loander :loading="httpEspera">
                <div class="row">
                  <dl class="col-md-3">
                    <dt class="text-dark">Código</dt>
                    <dd>{{ pedido.soc_codigo }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Data/Hora</dt>
                    <dd>{{ pedido.soc_datahora }}</dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Motivo</dt>
                    <dd>{{ pedido.soc_motivo | motivoCancelamento }}</dd>
                  </dl>
                </div>
                <div class="row">
                  <dl class="col-md-12">
                    <dt class="text-dark">Usuário Requerente</dt>
                    <dd>{{ pedido.usuario }}</dd>
                  </dl>
                </div>
                <div class="row">
                  <dl class="col-md-12">
                    <dt class="text-dark">Justificativa</dt>
                    <dd>{{ pedido.soc_justificativa }}</dd>
                  </dl>
                </div>
                <div class="row">
                  <dl class="col-md-12">
                    <dt class="text-dark">Arquivo em anexo</dt>
                    <dd v-if="pedido.soc_arquivo">
                      <a target="_blank" title="Baixar arquivo" v-bind:href="pedido.soc_arquivo">Clique aqui para baixar
                        o
                        arquivo</a>
                    </dd>
                    <dd v-else>Nenhum arquivo anexado</dd>
                  </dl>
                </div>
              </loander>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-sm-12 mt-3">
        <b-card no-body class="mb-1 border border-dark shadow-none">
          <b-card-header class="bg-dark" header-tag="header">
            <h6 class="m-0 text-white">
              Resposta ao Pedido
            </h6>
          </b-card-header>
          <b-card-body>
            <loander :loading="httpEspera">
              <b-card-text>
                <div class="row">
                  <dl class="col-md-3">
                    <dt class="text-dark">Situação</dt>
                    <dd>
                      <span v-show="pedido.soc_status === '1'" class="badge badge-warning font-size-11">Pendente</span>
                      <span v-show="pedido.soc_status  === '2'" class="badge badge-danger font-size-11">Rejeitado</span>
                      <span v-show="pedido.soc_status  === '3'" class="badge badge-info font-size-11">Aprovado</span>
                    </dd>
                  </dl>
                  <dl class="col-md-3">
                    <dt class="text-dark">Data/Hora do Atendimento</dt>
                    <dd v-if="pedido.soc_datahora_aprovacao">{{ pedido.soc_datahora_aprovacao }}</dd>
                    <dd v-else>-</dd>
                  </dl>
                </div>
                <div class="row">
                  <dl class="col-md-12">
                    <dt class="text-dark">Fiscal Responsável</dt>
                    <dd v-if="pedido.fiscal">{{ pedido.fiscal }}</dd>
                    <dd v-else>-</dd>
                  </dl>
                </div>
                <div v-if="usuario.is_admin">
                  <div v-if="!pedido.soc_datahora_aprovacao">
                    <div class="row">
                      <dl class="col-md-3">
                        <dt class="text-dark">Alterar situação para</dt>
                        <dd>
                          <select id="filtros-status"
                                  v-model="pedido_resposta.soc_status"
                                  class="custom-select" type="text">
                            <option value="2">Rejeitado</option>
                            <option value="3">Aprovado</option>
                          </select>
                        </dd>
                      </dl>
                    </div>
                    <div v-show="pedido_resposta.soc_status === '2'" class="row">
                      <dl class="col-md-12">
                        <dt class="text-dark">Justificativa da Decisão</dt>
                        <dd>
                    <textarea
                        v-model="pedido_resposta.soc_resposta"
                        class="form-control"
                        :class="{'is-invalid': $v.pedido_resposta.soc_resposta.$error}"
                        rows="4"
                        placeholder="Informe uma justificativa para decisão"></textarea>
                          <div v-if="$v.pedido_resposta.soc_resposta.$error" class="invalid-feedback">
                            Informe a justificativa
                          </div>
                        </dd>
                      </dl>
                    </div>
                    <div class="row mb-0">
                      <dl class="col-md-12 mb-0">
                        <dd>
                          <button type="button"
                                  @click="confirmacao(pedido)"
                                  class="btn btn-label btn-success"><i
                              class="bx bx-save label-icon"></i>
                            Salvar
                          </button>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div v-else class="row">
                    <dl class="col-md-12">
                      <dt class="text-dark">Justificativa da Decisão</dt>
                      <dd>{{ pedido.soc_resposta }}</dd>
                    </dl>
                  </div>
                </div>
                <div v-else class="row">
                  <dl class="col-md-12">
                    <dt class="text-dark">Justificativa da Decisão</dt>
                    <dd v-if="pedido.soc_resposta">{{ pedido.soc_resposta }}</dd>
                    <dd v-else>-</dd>
                  </dl>
                </div>
              </b-card-text>
            </loander>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-sm-12 mt-3">
        <b-card no-body class="mb-1 border border-danger shadow-none">
          <b-card-header class="bg-danger" header-tag="header">
            <h6 class="m-0 text-white">
              Nota Fiscal Cancelada
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <div class="col-md-12">
                  <embed :src="link_nota_cancelada" style="width:100%; height:120em;" type="text/html">
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <div v-if="link_nota_correta" class="col-sm-12 mt-3">
        <b-card no-body class="mb-1 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Nota Fiscal Correta
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <div class="col-md-12">
                  <embed :src="link_nota_correta" style="width:100%; height:120em;" type="text/html">
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import Loander from "../../../components/widgets/loader"
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import Swal from "sweetalert2";

const {openDownloadFile} = require("../../../api/core/download");
const {getNotaPedidoCancelamento} = require("../../../api/nfse/nota");
const {postPedidosCancelamento} = require("../../../api/admin/gestao/pedidos_cancelamento");
const {urlTemp} = require("../../../helps/impressao");
const {setRelNotaFiscal} = require("../../../api/relatorio/nota_fiscal");

export default {
  page: {
    title: "Pedido de Cancelamento",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Loander
  },
  data() {
    return {
      title: "Pedido de Cancelamento",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Pedido de Cancelamento',
          active: true,
        },
      ],
      httpSend: false,
      httpEspera: false,
      filtros: {
        status: '1',
        numero: "",
        pes_nome: ""
      },
      link_nota_cancelada: "",
      link_nota_correta: null,
      pedido: {},
      pedido_resposta: {
        soc_codigo: null,
        not_codigo: null,
        soc_status: '3',
        soc_resposta: ''
      }
    };
  },
  validations: {
    pedido_resposta: {
      soc_resposta: {
        required,
      },
    },
  },
  created() {
    if (this.empresa || this.usuario) {
      this.getPedido()
    }
  },
  computed: {
    usuario: {
      get: function () {
        return this.$store.state.auth.currentUser;
      },
    },
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    getPedido() {
      this.httpEspera = true;
      const eco_codigo = this.usuario.is_admin ? 0 : this.empresa.eco_codigo;
      getNotaPedidoCancelamento(eco_codigo, this.$route.params.codigo).then(result => {
        if (result.status) {
          this.pedido = result.dados
          if (result.dados.soc_arquivo) {
            this.pedido.soc_arquivo = openDownloadFile(5, btoa(result.dados.soc_arquivo), 'solicitação_' + this.pedido.soc_codigo + '.pdf', false)
          }
          if (this.pedido.not_hash) {
            this.visualizaNota(this.pedido.not_hash)
          }
          if (this.pedido.not_hash_correta) {
            this.visualizaNotaCorreta(this.pedido.not_hash_correta)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    visualizaNota(not_hash) {
      this.httpEspera = true;
      urlTemp(setRelNotaFiscal(not_hash)).then(result => {
        this.link_nota_cancelada = result;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpEspera = false;
      })
    },
    visualizaNotaCorreta(not_hash) {
      this.httpEspera = true;
      urlTemp(setRelNotaFiscal(not_hash)).then(result => {
        this.link_nota_correta = result;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpEspera = false;
      })
    },
    confirmacao(pedido) {
      Swal.fire({
        title: "Confirma a decisão?",
        text: "Não será mais possível reverter essa ação",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.savePedido(pedido)
        }
      });
    },
    savePedido(pedido) {
      if (this.pedido_resposta.soc_status === '2') {
        this.$v.$touch();
        if (this.$v.pedido_resposta.$invalid) {
          return false;
        }
      }
      this.pedido_resposta.soc_codigo = pedido.soc_codigo;
      this.pedido_resposta.not_codigo = pedido.not_codigo;
      this.httpSend = true;
      postPedidosCancelamento(this.pedido_resposta).then(result => {
        if (result.status) {
          this.$router.push({name: 'admin-gestao-pedidos-cancelamento'})
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>


